module.exports = __webpack_public_path__ + "static/media/road.36a6a0be.svg";